import {
  Component,
  ComponentInterface,
  h,
  Prop,
  State,
  Event,
  EventEmitter,
  Host,
  Watch,
} from "@stencil/core";
import { IThemeOptions, ISelectOption } from "../../../models";
import { ThemeService } from "../../../services";

@Component({
  tag: "av-select",
  styleUrl: "av-select.scss",
  shadow: true,
})
export class AvSelect implements ComponentInterface {
  @Prop() selected: ISelectOption;
  @Prop() selectedLabel: "value" | "label";

  @State() selection: ISelectOption;
  @State() themeOptions: IThemeOptions;

  @Prop() options: ISelectOption[];
  @Prop() prefixText: string;

  @Event({ bubbles: false }) changeComplete: EventEmitter<ISelectOption>;

  constructor() {
    if (this.selected) {
      this.selection = { ...this.selected };
    } else if (this.options && this.options.length > 0) {
      this.selection = this.options[0];
    } else {
      this.selection = { label: "-", value: null };
    }
    ThemeService.optionsAvailable().subscribe(
      (options) => (this.themeOptions = options)
    );
  }

  @Watch("selected")
  selectedChanged(selected: ISelectOption) {
    this.selection = { ...selected };
  }

  change(event) {
    const selection: ISelectOption = JSON.parse(event.target.value);
    this.selection = selection;
    this.changeComplete.emit(selection);
  }

  render() {
    return (
      <Host
        class={{
          "av-select": true,
          "av-select-dark": this.themeOptions.darkMode,
        }}
      >
        {this.prefixText && <div>{this.prefixText}</div>}
        {this.selection &&
          (this.selectedLabel === "label" || !this.selectedLabel) && (
            <div>{this.selection.label}</div>
          )}
        {this.selection && this.selectedLabel === "value" && (
          <div>{this.selection.value}</div>
        )}
        <select onChange={this.change.bind(this)}>
          {this.options.map((option) => {
            return (
              <option
                selected={this.selection.value == option.value}
                disabled={option.disabled ?? false}
                value={JSON.stringify(option)}
              >
                {option.label}
              </option>
            );
          })}
        </select>
        <i class={{ "av-select-chevron-dark": this.themeOptions.darkMode }}></i>
      </Host>
    );
  }
}
